import { makeActionCreator, reduce } from '../../helpers/utils';
import { SeasonTicketVendorNotFound } from '../../api/ApiErrorCodes';

const debug = require('debug')('jp:stores:forms:seasonTickets');

const LOAD = 'seasonTickets/LOAD';
const LOAD_SUCCESS = 'seasonTickets/LOAD_SUCCESS';
const LOAD_FAIL = 'seasonTickets/LOAD_FAIL';

const CHECKOUT_SUBMITTING = 'seasonTickets/CHECKOUT_SUBMITTING';

export const CHECKOUT = 'seasonTickets/CHECKOUT';
export const CHECKOUT_SUCCESS = 'seasonTickets/CHECKOUT_SUCCESS';
export const CHECKOUT_FAIL = 'seasonTickets/CHECKOUT_FAIL';

const initialState = {
  loaded: false,
  loading: false,
  location: null,
  submitting: false,
  success: false,
  errors: {}, // individual field errors
  error: false, // global form error from checkout step
  errorMsg: null,
  bootstrapFail: false,
  vendorNotFound: false
};

export default reduce(initialState, {
  [LOAD](state) {
    debug(LOAD);
    return { ...state, loading: !state.loading };
  },
  [LOAD_SUCCESS](state, action) {
    debug(LOAD_SUCCESS, action.payload.data);

    return {
      ...state,
      bootstrap: action.payload.data,
      loading: !state.loading,
      loaded: !state.loaded,
      bootstrapFail: false
    };
  },
  [LOAD_FAIL](state, action) {
    debug(LOAD_FAIL, action);
    return {
      ...state,
      loading: !state.loading,
      bootstrapFail: true,
      vendorNotFound: action.payload.error === SeasonTicketVendorNotFound
    };
  },
  [CHECKOUT_SUBMITTING](state, action) {
    debug(CHECKOUT_SUBMITTING);
    return {
      ...state,
      submitting: action.bool,
      errorMsg: ''
    };
  },
  [CHECKOUT](state) {
    debug(CHECKOUT);
    return {
      ...state,
      submitting: true,
      errorMsg: ''
    };
  },
  [CHECKOUT_SUCCESS](state, action) {
    debug(CHECKOUT_SUCCESS);
    if (
      __CLIENT__ &&
      (action.ticketType !== 'multi_usage' &&
        action.ticketType !== 'resident_ticket')
    ) {
      window.location.href = '/dashboard/season-tickets/';
    }
    return { ...state, submitting: false, success: true };
  },
  [CHECKOUT_FAIL](state, action) {
    debug(CHECKOUT_FAIL, action.payload);

    return {
      ...state,
      submitting: false,
      errors:
        action.payload &&
        action.payload.meta &&
        Object.keys(action.payload.meta).length
          ? action.payload.meta
          : {},
      errorMsg:
        action.payload &&
        action.payload.message &&
        !Object.keys(action.payload.meta).length
          ? action.payload.message
          : ''
    };
  }
});

export function load(vendor) {
  return {
    types: [LOAD, LOAD_SUCCESS, LOAD_FAIL],
    promise: client => client.seasonTickets.bootstrap(vendor)
  };
}

export const isSubmitting = makeActionCreator(CHECKOUT_SUBMITTING, 'bool');

export function checkout(data) {
  return {
    types: [CHECKOUT, CHECKOUT_SUCCESS, CHECKOUT_FAIL],
    promise: client => client.seasonTickets.checkout(data),
    ticketType: data.ticketType
  };
}
